

const commonIconButtonStyles = {
    background: 'linear-gradient(145deg, #2c2c2c, #1a1a1a)',
    width: 40,
    height: 40,
    '&:hover': {
      background: 'linear-gradient(145deg, #1a1a1a, #2c2c2c)',
      transform: 'translateY(-2px)',
      boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
    },
    transition: 'all 0.2s ease-in-out',
    boxShadow: '0 3px 10px rgba(0,0,0,0.2)',
    border: '1px solid rgba(255,255,255,0.1)',
  };
  
  const commonIconStyles = {
    color: '#ffffff',
    fontSize: 20
  };
  
  const commonActionButtonStyles = {
    background: 'linear-gradient(145deg, #2c2c2c, #1a1a1a)',
    color: '#ffffff',
    '&:hover': {
      background: 'linear-gradient(145deg, #1a1a1a, #2c2c2c)',
      boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
    },
    transition: 'all 0.2s ease-in-out',
  };
  
  export { commonIconButtonStyles, commonIconStyles, commonActionButtonStyles }; 